import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-4"
};
const _hoisted_2 = {
  class: "flex-center flex-col"
};
const _hoisted_3 = {
  class: "font-normal"
};
const _hoisted_4 = {
  class: "flex-center px-6"
};
const _hoisted_5 = {
  class: "flex-center px-6"
};
const _hoisted_6 = {
  class: "flex-center px-6"
};
const _hoisted_7 = {
  class: "flex items-center h-full"
};
import { Match } from "@/modules/match/entity";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import ActionLayout from "@/modules/base/layouts/ActionLayout.vue";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";
import { onBeforeRouteLeave } from "vue-router";
import SettingRepository from "@/modules/settings/services/SettingRepository";
import LiveIncident from "@/modules/match/components/LiveIncident.vue";
import SubstitutionDialog from "@/modules/match/components/SubstitutionDialog.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import MatchScore from "@/modules/match/components/MatchScore.vue";
import MatchLanes from "@/modules/match/components/MatchLanes.vue";
import MatchPlayerList from "@/modules/match/components/MatchPlayerList.vue";
import { EventEmitter } from "@/modules/base/events";
import { AfterMatchChangePossessionEvent } from "@/modules/match/events/AfterMatchChangePossessionEvent";
import { AfterMatchProgressBallPositionEvent } from "@/modules/match/events/AfterMatchProgressBallPositionEvent";
import { AfterMatchLaneCalculatedEvent } from "@/modules/match/events/AfterMatchLaneCalculatedEvent";
import MatchIncidentList from "@/modules/match/components/MatchIncidentList.vue";
import StadiumLogLoader from "@/modules/stadium/components/StadiumLogLoader.vue";
import StadiumLog from "@/modules/stadium/components/StadiumLog.vue";
import ToggleButton from "@/modules/vue/components/ToggleButton.vue";
import MatchStats from "@/modules/match/components/MatchStats.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchEvaluation',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const match = ref();
    const minute = ref(0);
    const isEvaluating = ref(true);
    const isFinished = ref(false);
    const incidents = ref([]);
    const configRepository = app.get(ConfigRepository);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      match.value = LiveMatchEvaluator.nextMatch ?? (await Match.createQueryBuilder('match').leftJoinAndSelect('match.connectedMatch', 'connectedMatch').innerJoinAndSelect('match.homeTeam', 'homeTeam').innerJoinAndSelect('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoinAndSelect('matchday.division', 'division').innerJoinAndSelect('division.competition', 'competition').leftJoinAndSelect('homeTeam.players', 'homePlayer').leftJoinAndSelect('awayTeam.players', 'awayPlayer').leftJoinAndSelect('homePlayer.country', 'homeCountry').leftJoinAndSelect('homePlayer.suspensions', 'homeSuspension').leftJoinAndSelect('awayPlayer.country', 'awayCountry').leftJoinAndSelect('awayPlayer.suspensions', 'awaySuspension').leftJoinAndSelect('match.incidents', 'incident').leftJoinAndSelect('incident.player', 'incidentPlayer').where('match.id = :matchId AND match.result IS NULL', {
        matchId: route.params.id
      }).getOneOrFail());
    })), __temp = await __temp, __restore(), __temp);
    const settingRepository = app.get(SettingRepository);
    const liveMatchEvaluator = ref(app.get(LiveMatchEvaluator));
    const settings = ref({
      fastSpeed: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('match_evaluation_fast_speed')), __temp = await __temp, __restore(), __temp),
      showIncidents: ([__temp, __restore] = _withAsyncContext(() => settingRepository.get('match_evaluation_show_incidents')), __temp = await __temp, __restore(), __temp)
    });
    const ballPosition = ref(2);
    const possession = ref('home');
    const lanes = ref();
    // @ts-ignore
    onBeforeUnmount(app.get(EventEmitter).onOff(AfterMatchChangePossessionEvent, event => {
      possession.value = event.possession;
    }));
    // @ts-ignore
    onBeforeUnmount(app.get(EventEmitter).onOff(AfterMatchProgressBallPositionEvent, event => {
      ballPosition.value = event.ballPosition;
    }));
    // @ts-ignore
    onBeforeUnmount(app.get(EventEmitter).onOff(AfterMatchLaneCalculatedEvent, event => {
      lanes.value = event.lanes;
    }));
    watch(() => settings.value.fastSpeed, async value => {
      if (value) {
        liveMatchEvaluator.value.setFast();
      } else {
        liveMatchEvaluator.value.setSlow();
      }
    });
    watch(() => settings.value.showIncidents, async () => {
      // todo
    });
    const currentLiveIncident = ref();
    const liveIncidentDialog = ref(null);
    onMounted(async () => {
      if (settings.value.fastSpeed) {
        liveMatchEvaluator.value.setFast();
      } else {
        liveMatchEvaluator.value.setSlow();
      }
      await liveMatchEvaluator.value.setNeedDecision(match.value.needDecision, match.value.connectedMatch).setOnPauseChange(async tick => {
        isEvaluating.value = tick.evaluator.isPaused;
      }).setOnTick(async tick => {
        minute.value = tick.minute;
      }).setOnIncident(async liveIncident => {
        if (settings.value.showIncidents) {
          currentLiveIncident.value = liveIncident;
          await nextTick(async () => {
            await liveIncidentDialog.value.show();
          });
        }
        incidents.value.push(liveIncident.incident);
        await waitFor(configRepository.get('match.evaluation.waitWhenDisplayingIncident'));
      }).setOnFinished(async () => {
        LiveMatchEvaluator.nextMatch = null;
        isFinished.value = true;
        isEvaluating.value = false;
      }).evaluate(match.value);
    });
    const substitutionDialog = ref(null);
    const onClickSubstitution = async () => {
      await liveMatchEvaluator.value.startInteraction();
      const subs = await substitutionDialog.value.show();
      const team = match.value.homeTeam.user ? match.value.homeTeam : match.value.awayTeam;
      await Object.keys(subs).forEachAsync(async k => {
        await liveMatchEvaluator.value.substitute(team, team.players.find(p => p.id === subs[k]), team.players.find(p => p.id === Number.parseInt(k)));
      });
      await liveMatchEvaluator.value.endInteraction();
    };
    const onClickAction = async () => {
      if (isFinished.value) {
        await settingRepository.set('match_evaluation_fast_speed', settings.value.fastSpeed);
        await settingRepository.set('match_evaluation_show_incidents', settings.value.showIncidents);
        router.push({
          name: 'matches.evaluation.after',
          params: route.params
        });
        return;
      }
      if (isEvaluating.value) {
        liveMatchEvaluator.value.pause();
        isEvaluating.value = false;
      } else {
        liveMatchEvaluator.value.unpause();
        isEvaluating.value = true;
      }
    };
    const actionIcon = computed(() => isEvaluating.value ? IconEnum.PauseCircle : IconEnum.PlayCircle);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_NTabPane = _resolveComponent("NTabPane");
      const _component_NTabs = _resolveComponent("NTabs");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(ActionLayout, {
        position: "end",
        "action-icon": _unref(actionIcon),
        onClickAction: onClickAction
      }, {
        actionPanel: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(ToggleButton, {
          modelValue: settings.value.fastSpeed,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => settings.value.fastSpeed = $event),
          "icon-on": _ctx.IconEnum.FastForward20Regular,
          "icon-off": _ctx.IconEnum.FastForward20Regular,
          class: "mr-2"
        }, null, 8, ["modelValue", "icon-on", "icon-off"]), _createVNode(ToggleButton, {
          modelValue: settings.value.showIncidents,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => settings.value.showIncidents = $event),
          "icon-on": _ctx.IconEnum.AlertOn20Regular,
          "icon-off": _ctx.IconEnum.AlertOff20Regular,
          class: "mr-2"
        }, null, 8, ["modelValue", "icon-on", "icon-off"]), _createVNode(_component_NButton, {
          secondary: "",
          type: "primary",
          disabled: isFinished.value,
          onClick: onClickSubstitution
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.ArrowsHorizontal
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createVNode(SubstitutionDialog, {
          ref_key: "substitutionDialog",
          ref: substitutionDialog,
          match: match.value,
          "live-match-evaluator": liveMatchEvaluator.value
        }, null, 8, ["match", "live-match-evaluator"]), _createVNode(LiveIncident, {
          ref_key: "liveIncidentDialog",
          ref: liveIncidentDialog,
          "live-incident": currentLiveIncident.value,
          "live-match-evaluator": liveMatchEvaluator.value,
          onDisableIncidents: _cache[0] || (_cache[0] = () => settings.value.showIncidents = false)
        }, null, 8, ["live-incident", "live-match-evaluator"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_NDivider, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(match.value.matchday.division.competition.name) + ", " + _toDisplayString(match.value.matchday.division.name), 1), _createVNode(StadiumLogLoader, {
            match: match.value,
            class: "mb-2 text-base"
          }, {
            default: _withCtx(({
              stadium,
              stadiumLog
            }) => [_createVNode(StadiumLog, {
              stadium: stadium,
              "stadium-log": stadiumLog
            }, null, 8, ["stadium", "stadium-log"])]),
            _: 1
          }, 8, ["match"])])]),
          _: 1
        }), _createVNode(MatchScore, {
          match: match.value,
          incidents: incidents.value,
          minute: minute.value
        }, null, 8, ["match", "incidents", "minute"])]), _createVNode(_component_NTabs, {
          "default-value": "incidents",
          "justify-content": "space-evenly",
          type: "line"
        }, {
          default: _withCtx(() => [_createVNode(_component_NTabPane, {
            name: "incidents",
            tab: _ctx.$t('incidents')
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(Icon, {
              icon: _ctx.IconEnum.MegaphoneLoud20Regular
            }, null, 8, ["icon"])])]),
            default: _withCtx(() => [_createVNode(MatchLanes, {
              "ball-position": ballPosition.value,
              possession: possession.value,
              lanes: lanes.value,
              class: "mb-2"
            }, null, 8, ["ball-position", "possession", "lanes"]), _createVNode(MatchIncidentList, {
              match: match.value,
              incidents: incidents.value
            }, null, 8, ["match", "incidents"])]),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_NTabPane, {
            name: "stats"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(Icon, {
              icon: _ctx.IconEnum.ChartMultiple20Regular
            }, null, 8, ["icon"])])]),
            default: _withCtx(() => [_createVNode(MatchStats, {
              match: match.value
            }, null, 8, ["match"])]),
            _: 1
          }), _createVNode(_component_NTabPane, {
            name: "lineup"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(Icon, {
              icon: _ctx.IconEnum.ChartPerson20Regular
            }, null, 8, ["icon"])])]),
            default: _withCtx(() => [_createVNode(MatchPlayerList, {
              team: match.value.homeTeam.user ? match.value.homeTeam : match.value.awayTeam,
              "suspended-player-ids": liveMatchEvaluator.value.suspendedPlayerIds
            }, null, 8, ["team", "suspended-player-ids"]), _ctx.$debug ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createVNode(_component_NDivider), _createVNode(MatchPlayerList, {
              team: !match.value.homeTeam.user ? match.value.homeTeam : match.value.awayTeam,
              "suspended-player-ids": liveMatchEvaluator.value.suspendedPlayerIds
            }, null, 8, ["team", "suspended-player-ids"])], 64)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["action-icon"]);
    };
  }
});